(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        // eslint-disable-next-line no-console
        this.board = initialState;
        this.score = 0;
        this.button = document.querySelector(".button");
        this.isStarted = false;
        this.handleClick = this.startOrRestart.bind(this);
        this.button.addEventListener("click", this.handleClick);
        this.tableCells = document.querySelectorAll(".field-cell");
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var boardChanged = false;
                for(var row = 0; row < this.board.length; row++){
                    var currentRow = this.board[row];
                    var newRow = currentRow.filter(function(value) {
                        return value !== 0;
                    });
                    for(var i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1]) {
                        newRow[i] = newRow[i] * 2;
                        newRow[i + 1] = 0;
                        this.score += newRow[i];
                        boardChanged = true;
                    }
                    newRow = newRow.filter(function(value) {
                        return value !== 0;
                    });
                    while(newRow.length < 4)newRow.push(0);
                    this.board[row] = newRow;
                    if (JSON.stringify(currentRow) !== JSON.stringify(newRow)) boardChanged = true;
                }
                if (boardChanged) {
                    this.placeRandomNumber(this.board);
                    this.renderBoard();
                    this.renderScore();
                }
                this.has2048Tile();
                if (this.checkLose()) this.showLoseMessage();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var boardChanged = false;
                for(var row = 0; row < this.board.length; row++){
                    var currentRow = this.board[row];
                    var newRow = currentRow.filter(function(value) {
                        return value !== 0;
                    });
                    for(var i = newRow.length - 1; i > 0; i--)if (newRow[i] === newRow[i - 1]) {
                        newRow[i] = newRow[i] * 2;
                        newRow[i - 1] = 0;
                        this.score += newRow[i];
                        boardChanged = true;
                    }
                    newRow = newRow.filter(function(value) {
                        return value !== 0;
                    });
                    while(newRow.length < 4)newRow.unshift(0);
                    this.board[row] = newRow;
                    if (JSON.stringify(currentRow) !== JSON.stringify(newRow)) boardChanged = true;
                }
                if (boardChanged) {
                    this.placeRandomNumber(this.board);
                    this.renderBoard();
                    this.renderScore();
                }
                this.has2048Tile();
                if (this.checkLose()) this.showLoseMessage();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var boardChanged = false;
                this.board = this.transpose(this.board);
                for(var row = 0; row < this.board.length; row++){
                    var currentRow = this.board[row];
                    var newRow = currentRow.filter(function(value) {
                        return value !== 0;
                    });
                    for(var i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1]) {
                        newRow[i] = newRow[i] * 2;
                        newRow[i + 1] = 0;
                        this.score += newRow[i];
                        boardChanged = true;
                    }
                    newRow = newRow.filter(function(value) {
                        return value !== 0;
                    });
                    while(newRow.length < 4)newRow.push(0);
                    this.board[row] = newRow;
                    if (JSON.stringify(currentRow) !== JSON.stringify(newRow)) boardChanged = true;
                }
                this.board = this.transpose(this.board);
                if (boardChanged) {
                    this.placeRandomNumber(this.board);
                    this.renderBoard();
                    this.renderScore();
                }
                this.has2048Tile();
                if (this.checkLose()) this.showLoseMessage();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var boardChanged = false;
                this.board = this.transpose(this.board);
                for(var row = 0; row < this.board.length; row++){
                    var currentRow = this.board[row];
                    var newRow = currentRow.filter(function(value) {
                        return value !== 0;
                    });
                    for(var i = newRow.length - 1; i > 0; i--)if (newRow[i] === newRow[i - 1]) {
                        newRow[i] = newRow[i] * 2;
                        newRow[i - 1] = 0;
                        this.score += newRow[i];
                        boardChanged = true;
                    }
                    newRow = newRow.filter(function(value) {
                        return value !== 0;
                    });
                    while(newRow.length < 4)newRow.unshift(0);
                    this.board[row] = newRow;
                    if (JSON.stringify(currentRow) !== JSON.stringify(newRow)) boardChanged = true;
                }
                this.board = this.transpose(this.board);
                if (boardChanged) {
                    this.placeRandomNumber(this.board);
                    this.renderBoard();
                    this.renderScore();
                }
                this.has2048Tile();
                if (this.checkLose()) this.showLoseMessage();
            }
        },
        {
            key: "transpose",
            value: function transpose(board) {
                return board[0].map(function(_, colIndex) {
                    return board.map(function(row) {
                        return row[colIndex];
                    });
                });
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                var scoreElement = document.querySelector(".game-score");
                scoreElement.textContent = this.score;
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * idle - the game has not started yet (the initial state);
   * playing - the game is in progress;
   * win - the game is won;
   * lose - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                if (!this.isStarted) return "idle";
                else if (this.checkWin()) return "win";
                else if (this.checkLose()) return "lose";
                else return "playing";
            }
        },
        {
            key: "startOrRestart",
            value: function startOrRestart() {
                if (this.isStarted) this.restart();
                else this.start();
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                var messageElement = document.querySelector(".message.message-start");
                messageElement.textContent = "The game has started! Use the arrow keys to play.";
                this.button.classList.remove("start");
                this.button.classList.add("restart");
                this.button.textContent = "Restart";
                this.isStarted = true;
                this.placeRandomNumber(this.board);
                this.placeRandomNumber(this.board);
                this.renderBoard();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                var messageElement = document.querySelector(".message.message-start");
                var messageLoseElement = document.querySelector(".message-lose");
                var gameScore = document.querySelector(".game-score");
                if (!messageLoseElement.classList.contains("hidden")) messageLoseElement.classList.add("hidden");
                messageElement.textContent = 'Press "Start" to begin game. Good luck!';
                messageElement.classList.remove("hidden");
                this.button.classList.remove("restart");
                this.button.classList.add("start");
                this.button.textContent = "Start";
                this.isStarted = false;
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
                gameScore.textContent = 0;
                this.renderBoard();
            }
        },
        {
            key: "getRandomInt",
            value: function getRandomInt(min, max) {
                return Math.floor(Math.random() * (max - min)) + min;
            }
        },
        {
            key: "placeRandomNumber",
            value: function placeRandomNumber(board) {
                var emptyCells = [];
                for(var row = 0; row < board.length; row++){
                    for(var col = 0; col < board[row].length; col++)if (board[row][col] === 0) emptyCells.push([
                        row,
                        col
                    ]);
                }
                if (emptyCells.length > 0) {
                    var randomIndex = this.getRandomInt(0, emptyCells.length);
                    var _emptyCells_randomIndex = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[randomIndex], 2), randomRow = _emptyCells_randomIndex[0], randomCol = _emptyCells_randomIndex[1];
                    board[randomRow][randomCol] = Math.random() > 0.1 ? 2 : 4;
                }
            }
        },
        {
            key: "renderBoard",
            value: function renderBoard() {
                var _this = this;
                this.tableCells.forEach(function(cell, index) {
                    var row = Math.floor(index / 4);
                    var col = index % 4;
                    if (_this.board[row][col] !== 0) {
                        cell.textContent = _this.board[row][col];
                        cell.className = "field-cell field-cell--".concat(_this.board[row][col]);
                    } else {
                        cell.textContent = "";
                        cell.className = "field-cell";
                    }
                });
            }
        },
        {
            key: "renderScore",
            value: function renderScore() {
                var scoreElement = document.querySelector(".game-score");
                scoreElement.textContent = this.score;
            }
        },
        {
            key: "has2048Tile",
            value: function has2048Tile() {
                for(var row = 0; row < this.board.length; row++)for(var col = 0; col < this.board[row].length; col++){
                    if (this.board[row][col] >= 2048) return this.showWinMessage();
                }
            }
        },
        {
            key: "showWinMessage",
            value: function showWinMessage() {
                var startMessage = document.querySelector(".message.message-start");
                var winMessage = document.querySelector(".message.message-win");
                var loseMessage = document.querySelector(".message.message-lose");
                startMessage.classList.add("hidden");
                loseMessage.classList.add("hidden");
                winMessage.classList.remove("hidden");
            }
        },
        {
            key: "showLoseMessage",
            value: function showLoseMessage() {
                var startMessage = document.querySelector(".message.message-start");
                var winMessage = document.querySelector(".message.message-win");
                var loseMessage = document.querySelector(".message.message-lose");
                startMessage.classList.add("hidden");
                winMessage.classList.add("hidden");
                loseMessage.classList.remove("hidden");
            }
        },
        {
            key: "checkLose",
            value: function checkLose() {
                for(var row = 0; row < this.board.length; row++)for(var col = 0; col < this.board[row].length; col++){
                    if (this.board[row][col] === 0) return false;
                }
                for(var row1 = 0; row1 < this.board.length; row1++)for(var col1 = 0; col1 < this.board[row1].length; col1++){
                    if (col1 < this.board[row1].length - 1 && this.board[row1][col1] === this.board[row1][col1 + 1]) return false;
                    if (row1 < this.board.length - 1 && this.board[row1][col1] === this.board[row1 + 1][col1]) return false;
                }
                return true;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$initialState = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports($197cd56b15c33885$var$initialState);
document.addEventListener("keydown", function(e) {
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
    }
});

})();
//# sourceMappingURL=js-2048-game.d3e1df02.js.map
